/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-22 14:26:12
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 11:12:39
 */
export const zsRouter = [
	'/index',
	'/index/home',
	'/shopManage',
	'/shopManage/pallet',
	'/shopManage/shopLibrary',
	'/shopManage/shopLibrary/list',
	'/shopManage/shopLibrary/shopLibraryDetails',
	'/shopManage/shopGroup',
	'/shopManage/shopGroup/group',
	'/shopManage/shopGroup/record',
	'/shopManage/shopGroup/detail',
	'/shopGroup/detail/list',
	'/shopGroup/detail/shopDetails',
	'/cooperationProgress',
	'/cooperationProgress/list',
	'/cooperationProgress/details',
	'/cooperationProgress/record',
	'/tobeClaime',
	'/tobeClaime/list',
	'/tobeClaime/detail',
	'/trusteeship',
	'/trusteeship/list',
	'/trusteeship/detail',
	'/shopLibrary/waste',
	'/shopLibrary/record',
	'/personal',
	'/personal/center',
	'/secondColonelManage',
	'/secondColonelManage/colonelActivitySquare',
	'/secondColonelManage/colonelActivitySquare/list',
	'/secondColonelManage/colonelActivitySquare/detail',
	'/secondColonelManage/myActivities',
	'/secondColonelManage/myActivities/list',
	'/secondColonelManage/myActivities/detail',
	'/secondColonelManage/cooperativeColonel',
	'/secondColonelManage/cooperativeColonel/list',
	'/secondColonelManage/cooperativeColonel/detail',
	'/sample',
	'/sample/list',
	'/order',
	'/order/list',
	'/order/record',
	'/ranking',
	'/ranking/issueTalent',
	'/ranking/issueProduct',
	'/ranking/issueHeader',
	'/ranking/record',
	'/selectionDecoration',
	'/selectionDecoration/list',
	'/cooperativeShop',
	'/cooperativeShop/list',
	'/libray',
	'/libray/local/list'
];
